<template>
    <div>
        <b-card v-for="cardDetails in CardList" :key="cardDetails.section">

            <b-card-header :class="{ 'collapsed': cardDetails.collapse }" v-b-toggle="cardDetails.section"
                :aria-expanded="cardDetails.collapse ? 'true' : 'false'" :aria-controls="cardDetails.section" role="tab"
                data-toggle="collapse">
                {{cardDetails.section}}
                <!-- <feather-icon icon="ChevronDownIcon" v-if="!cardDetails.collapse" />
                <feather-icon icon="ChevronUpIcon" v-else /> -->

            </b-card-header>

            <b-collapse v-model="cardDetails.collapse" :visible="cardDetails.visible" :id="cardDetails.section" class="card-content">
            <b-card-body>
                <InvoiceFields :ModuleReference="cardDetails.section"/>
            </b-card-body>
            </b-collapse>
        </b-card>

    </div>
</template>


<script>
import {
    BRow,
    BCol,
   
    BCard,
    BCardHeader,
    BCardBody,
    VBToggle
} from "bootstrap-vue";
import InvoiceFields from "@/views/component/Invoice.vue";
export default {
    components: {
        BRow,
        BCol,

        BCard,
        BCardHeader,
        BCardBody,
        InvoiceFields
    },
    directives: {
        'b-toggle': VBToggle
    },
    data() {
        return {
            CardList: [{
                collapse: true,
                visible: true,
                section: "Transaction Setting",
                customFields: []
            },
        ]
        }
    },
    async mounted() { },
    methods: { },
    computed:{ }
}

</script>